export default "__VITE_ASSET__BOKwAnko__"